import {
  auditSpotAuditSpotMediaList,
  getApiV2Client,
  getAuditSpotAuditSpotMediaDownloadUrl,
} from '@mi-front/api-v2';

/**
 * Builds a signed api-v2 URL for playing or downloading spot media by UUID.
 */
export function buildAuditMediaFileUrl(
  mediaId: string,
  options?: {
    download?: boolean;
  },
): string {
  const { url } = getAuditSpotAuditSpotMediaDownloadUrl(mediaId);

  return getApiV2Client().generateUrl(url, {
    secure: true,
    params: options?.download ? { download: 1 } : undefined,
  });
}

/**
 * Resolves spot media UUID from station + customId via api-v2 media list.
 */
export async function resolveAuditMediaIdByCustomId(
  stationId: string,
  customId: string,
): Promise<string | null> {
  const res = await auditSpotAuditSpotMediaList({
    station: stationId,
    filter: [`customId||$eq||${customId}`],
    limit: 1,
  });

  return res.data[0]?.id ?? null;
}
